import Axios from 'axios'
import * as React from 'react'
import { createContext, useState } from 'react'
import { postier } from '../Components/Dashboard/Postier'

export const AppContext = createContext(null)

export function AppProvider({children}) {

    const jour = new Date()
    const mois = jour.getMonth()+1
    const month = mois < 10 ? "0" + mois : mois
    const day = jour.getDate() < 10 ? "0" + jour.getDate() : jour.getDate()

    const [token, setToken] = useState<string>("")
    const [userId, setUserId] = useState<number>(0)
    const [role, setRole] = useState<string>("")
    const [appId, setAppId] = useState<number>(2)
    const [site, setSite] = useState( localStorage.getItem("site") ||"Veuillez choisir un client")
    const [page, setPage] = useState<string>(localStorage.getItem("page")||"site")
    const [loading, setLoading] = useState<boolean>(false)
    const [date, setDate] = useState(`${jour.getFullYear()}-${month}-${day}`)
    const [type, setType] = useState([])

    const [siteList, setSiteList] = useState([])

    const [client, setClient] = useState( localStorage.getItem("client")  || "")
    const [clients, setClients] = useState([])
    const [errors, setErrors] = useState<string[]>([])

    const refreshClient = (arg)=>{
        setClients(arg)
        setLoading(false)
    }


    React.useEffect(() => {
        if(userId) {
            setLoading(true)
            postier.getAllClients(token, refreshClient, userId, setErrors)
        }
    }, [userId])

    React.useEffect(() => {

        if (clients[0] && !clients.includes(client)){

            setClient(clients[0])
        }

    }, [clients])

    React.useEffect(() => {
        if(client!="" && client && token!="" && token){
            postier.getSites(token,client.split(":")[3],setSiteList, setErrors)
        }

    }, [client, site, token])

    React.useEffect(() => {
        // siteList[0] ? setSite( siteList[0]) : null;
        if(siteList[0]){

            const monsite = localStorage.getItem("site")
            let exist = false

            for (const s of siteList) {
                if (s==monsite){
                    exist=true
                }
            }

            if( monsite!=""&&monsite!=null&&exist){
                setSite(monsite)
            }else{
                setSite( siteList[0])
            }
        }

    }, [siteList])

    const [sites, setSiteData] = React.useState({
        ID: 0,
        Code: "",
        Name: "",
        Country: "",
        IsMonitored: 0,
        WeatherZipCode: "",
        ZipCode: 0
      })

      const setSites = (arg)=>{

         setLoading(false)
        setSiteData(arg)
      }

    React.useEffect(() => {
        setToken(localStorage.getItem("token"))
        setUserId(parseInt(localStorage.getItem("userid")))
    }, [])
    
    React.useEffect(()=>{
        localStorage.setItem("page",page)
    },[page])

    React.useEffect(()=>{
        localStorage.setItem("client", client)
        localStorage.setItem("site",site)
        localStorage.setItem("apiId", client.split(':')[2] || '1')
    },[client, site])

    const deconnexion = () => {
        Axios.post('/api-v0/disconnection')
        setToken(undefined)
        setUserId(0)
        localStorage.clear()
    }

    return (
        <AppContext.Provider value={{

            date, setDate,

            token, setToken,
            userId, setUserId,
            appId, setAppId,
            role, setRole,
            deconnexion,

            client, setClient,
            clients, setClients,
            site, setSite,
            sites, setSites,//infosite
            siteList, setSiteList,

            page, setPage,
            loading, setLoading,
            type, setType,
            errors,
            setErrors,
        }}>
            {children}
        </AppContext.Provider>
    )
}
